import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { TutorialTypes } from '../../../constants';
import { ActivatedRoute } from '../../../../../../node_modules/@angular/router';
@Component({
  selector: 'app-tutorial-tab',
  templateUrl: './tutorial-tab.component.html',
  styleUrls: ['./tutorial-tab.component.scss']
})
export class TutorialTabComponent implements OnInit {
TutorialTypes = TutorialTypes;
@Input() defaultTab: string;
tab: string;

@Output()
change: EventEmitter<boolean> = new EventEmitter<boolean>();
  constructor(private route: ActivatedRoute) { }

  ngOnInit() {
    this.tab = this.defaultTab;
    this.route.queryParams.subscribe(values => {
      if (Object.keys(TutorialTypes).map(k => k.split('_').join(' ')).includes(values.tutorialType)) {
        this.tab = values.tutorialType;
        this.change.emit(values.tutorialType !== undefined);
      }
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/components/tutorial/tutorial-tab/tutorial-tab.component.ts